import AddToCalendar from '@culturehq/add-to-calendar';
import React from 'react';

import {AddToCalendarButtonProps} from './AddToCalendarButton.props';
import './styles.css';

const AddToCalendarButton: React.FC<AddToCalendarButtonProps> = ({
  title,
  startDate,
  endDate,
  location,
  description,
}) => {
  return (
    <AddToCalendar
      event={{
        name: title,
        details: description || '',
        location: location || '',
        startsAt: startDate,
        endsAt: endDate,
      }}
    />
  );
};

export default AddToCalendarButton;
